import { render, staticRenderFns } from "./VModalCreateReport.vue?vue&type=template&id=48727a4f&"
import script from "./VModalCreateReport.vue?vue&type=script&lang=ts&"
export * from "./VModalCreateReport.vue?vue&type=script&lang=ts&"
import style0 from "./VModalCreateReport.vue?vue&type=style&index=0&id=48727a4f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports